// extracted by mini-css-extract-plugin
export default {"root":"ListCard_root__fVoKy","title":"ListCard_title__Cb9lw"};